import { forwardRef, type Ref, type SVGProps } from "react";
const IconIdBadgeFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 4a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm-4.738 9.33a2.54 2.54 0 0 0-2.5 0 2.45 2.45 0 0 0-1.25 2.13v.504a3.38 3.38 0 0 0 1.071 2.387c-.246.038-.715.14-.715.14-1.693.394-2.856 1.237-2.856 2.218v3.588c0 .388.32.703.714.703h8.57a.71.71 0 0 0 .716-.703v-3.588c0-.98-1.165-1.824-2.858-2.218l-.715-.14a3.4 3.4 0 0 0 1.073-2.387v-.503c0-.879-.477-1.691-1.25-2.13M15 7a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconIdBadgeFilledSVG);
ForwardRef.displayName = "IconIdBadgeFilled";
export { ForwardRef as IconIdBadgeFilled };
